import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Link } from '@chakra-ui/react';
import React from 'react'
import { Link as ReachLink } from "react-router-dom";

const DetailedViewRenderer = (props) => {
  const cellValue = props.valueFormatted ? props.valueFormatted : props.value;
  return (
    <>
      {
        cellValue && <Link
          color='blue.500'
          as={ReachLink}
          to={
            '/home/gen-ai/gen-ai-json/' + cellValue
          }
          isExternal
        >
          {cellValue}
          <ExternalLinkIcon mx="5px" />
        </Link>
      }
    </>
  )
}

export default DetailedViewRenderer